import React from "react";

const policies = [
  {
    title: "Căn cứ",
    content: (
      <div className="text-sm sm:text-base text-left">
        <ul className="list-none ">
          <li>
            - Luật Bảo vệ quyền lợi người tiêu dùng số 19/2023/QH15 do Quốc hội
            ban hành ngày 20/06/2023;
          </li>
          <li>
            Luật Viễn thông số 24/2023/QH15 do Quốc hội ban hành ngày 24/11/2023
            và các văn bản hướng dẫn thi hành;
          </li>
          <li>
            - Nghị định số 163/2024/NĐ-CP do Chính phủ ban hành ngày 24/12/2024
            quy định chi tiết một số điều và biện pháp thi hành Luật viễn thông;
          </li>
          <li>
            - Nghị định số 55/2024/NĐ-CP do Chính phủ ban hành ngày 16/05/2024
            quy định chi tiết một số điều của Luật bảo vệ quyền lợi người tiêu
            dùng;
          </li>
          <li>
            - Nghị định số 13/2023/NĐ-CP do Chính phủ ban hành ngày 17/04/2023
            về bảo vệ dữ liệu cá nhân;
          </li>
          <li>
            - Nghị định số 06/2016/NĐ-CP do Chính phủ ban hành ngày 18/01/2016
            quy định quản lý, cung cấp và sử dụng dịch vụ phát thanh, truyền
            hình sửa đổi bổ sung bởi Nghị định 71/2022/NĐ-CP;
          </li>
          <li>
            - Quyết định số 07/2024/QĐ-TTg do Thủ tướng Chính phủ ban hành ngày
            20/06/2024 ban hành Danh mục sản phẩm, hàng hóa, dịch vụ phải đăng
            ký hợp đồng theo mẫu, điều kiện giao dịch chung.
          </li>
          <li>
            Chính sách bảo vệ dữ liệu cá nhân đối với Khách hàng của VNPT (sau
            đây gọi tắt là “Chính sách”) nhằm mục đích thông báo với Khách hàng
            về các Thông tin Khách hàng do Tập đoàn Bưu chính Viễn thông Việt
            Nam (“VNPT”) xử lý, mục đích xử lý, cách thức xử lý, thời gian lưu
            trữ, quyền, nghĩa vụ của Khách hàng đối với Thông tin Khách hàng
            theo quy định của pháp luật Việt Nam về bảo vệ Thông tin Khách hàng.
            Chính sách này đồng thời đưa ra các khuyến nghị để giúp Khách hàng
            nâng cao nhận thức về bảo vệ Thông tin Khách hàng.
          </li>
          <li>
            Chính sách này là Điều kiện giao dịch chung được áp dụng cho toàn bộ
            hoạt động cung cấp Sản phẩm, dịch vụ của VNPT và áp dụng trên toàn
            bộ các nền tảng có tương tác với Khách hàng cá nhân trên môi trường
            số.
          </li>
          <li>
            VNPT có trách nhiệm cung cấp đầy đủ Chính sách này cho khách hàng
            trước khi ký hợp đồng hoặc giao dịch và lấy chấp thuận của Khách
            hàng đối với Chính sách này trước khi thực hiện hoạt động xử lý
            Thông tin Khách hàng theo quy định của pháp luật. Bằng việc tích vào
            ô "Chấp thuận" trên các website (trang mạng)/ứng dụng cung cấp dịch
            vụ của VNPT có đăng tải công khai Chính sách này; hoặc bằng việc ký
            kết hợp đồng với VNPT có dẫn chiếu và đính kèm Chính sách này; Khách
            hàng xác nhận rằng đã đọc kỹ, hiểu rõ và chấp thuận toàn bộ nội dung
            Chính sách này.
          </li>
        </ul>
      </div>
    ),
  },
  {
    title: "Điều 1. Giải thích từ ngữ và các từ viết tắt",
    content: (
      <div className="text-sm sm:text-base text-left">
        <ul className="list-none">
          <li>
            Trong phạm vi Chính sách này, các thuật ngữ dưới đây được hiểu và
            giải thích như sau:
          </li>
          <li>
            1. VNPT là Tập Đoàn Bưu Chính Viễn Thông Việt Nam và các đơn vị trực
            thuộc Tập Đoàn Bưu Chính Viễn Thông Việt Nam.
          </li>
          <li>2. Khách hàng là:</li>
          <li>
            - Cá nhân hoặc người đại diện hợp pháp của cá nhân sử dụng và/hoặc
            quan tâm tới các Sản phẩm, dịch vụ của VNPT;
          </li>
          <li>
            - Cá nhân hoặc người đại diện hợp pháp của cá nhân đã truy cập
            và/hoặc đăng ký tài khoản tại các website/ứng dụng cung cấp dịch vụ
            của VNPT.
          </li>
          <li>3. Sản phẩm, dịch vụ của VNPT là:</li>
          <li>
            - Dịch vụ viễn thông di động mặt đất (dịch vụ thoại, dịch vụ nhắn
            tin, dịch vụ truy nhập Internet);
          </li>
          <li>
            - Dịch vụ viễn thông cố định mặt đất (dịch vụ thoại, dịch vụ truy
            nhập Internet);
          </li>
          <li>- Dịch vụ truyền hình trả tiền;</li>
          <li>- Dịch vụ trung gian thanh toán và dịch vụ Mobile Money;</li>
          <li>
            - Các sản phẩm, dịch vụ khác do VNPT cung cấp cho Khách hàng theo
            quy định của pháp luật.
          </li>
          <li>
            4. Thông tin Khách hàng bao gồm (i) Dữ liệu cá nhân của Khách hàng
            theo quy định của pháp luật về bảo vệ dữ liệu cá nhân và (ii) Thông
            tin về quá trình mua, sử dụng sản phẩm, hàng hóa, dịch vụ của Khách
            hàng và thông tin khác liên quan đến giao dịch giữa Khách hàng và
            VNPT.
          </li>
        </ul>
      </div>
    ),
  },
  {
    title: "Điều 2. Xử lý Thông tin Khách hàng",
    content: (
      <div className="text-sm sm:text-base text-left">
        <ul className="list-none ">
          <li>
            1. VNPT có trách nhiệm thông báo Chính sách này cho Khách hàng và
            lấy chấp thuận của Khách hàng trước khi tiến hành xử lý Thông tin
            Khách hàng trong những trường hợp dưới đây:
          </li>
          <li>
            a) Khi Khách hàng hoặc người đại diện hợp pháp của Khách hàng liên
            hệ với VNPT để yêu cầu tư vấn Sản phẩm, dịch vụ của VNPT hoặc bày tỏ
            sự quan tâm tới các Sản phẩm, dịch vụ của VNPT;
          </li>
          <li>
            b) Khi Khách hàng dùng thử, ký kết hợp đồng, đăng ký, sử dụng Sản
            phẩm, dịch vụ của VNPT;
          </li>
          <li>
            c) Khi Khách hàng truy cập và/hoặc đăng ký tài khoản tại các
            website/ứng dụng cung cấp dịch vụ của VNPT;
          </li>
          <li>
            d) Khi Khách hàng đồng thuận cung cấp Thông tin Khách hàng cho VNPT
            qua các nguồn công khai như: website/ứng dụng cung cấp dịch vụ; cuộc
            họp, sự kiện, hội thảo, hội nghị, các mạng xã hội, hay chương trình
            đối thoại, thảo luận do VNPT tổ chức, tài trợ hoặc tham dự và/hoặc
            từ các tệp lưu trữ (cookies) ghi nhận được trên website/ứng dụng
            cung cấp dịch vụ của VNPT;
          </li>
          <li>
            e) Khi khách hàng của một tổ chức, doanh nghiệp cho phép tổ chức,
            doanh nghiệp đó chia sẻ Thông tin Khách hàng của khách hàng với
            VNPT;
          </li>
          <li>
            g) Là khách hàng của một tổ chức, doanh nghiệp được VNPT thực hiện
            góp vốn, mua cổ phần; hoặc là khách hàng của một tổ chức, doanh
            nghiệp có hoạt động hợp tác cung cấp sản phẩm, dịch vụ với VNPT.
          </li>
          <li>h) Khi có yêu cầu của các cơ quan nhà nước có thẩm quyền.</li>
          <li>
            i) Khi VNPT tiến hành các công việc theo mục đích xử lý Thông tin
            Khách hàng được quy định tại Điều 3 Chính sách này.
          </li>
          <li>j) Các trường hợp khác theo quy định của pháp luật.</li>
          <li>
            2. Dữ liệu cá nhân của Khách hàng được VNPT tiến hành xử lý (sau đây
            gọi tắt là “Dữ liệu cá nhân”) bao gồm:
          </li>
          <li>2.1 Dữ liệu cá nhân cơ bản</li>
          <li>a) Họ, chữ đệm và tên khai sinh, tên gọi khác (nếu có);</li>
          <li>
            b) Ngày, tháng, năm sinh; ngày, tháng, năm chết hoặc mất tích;
          </li>
          <li>c) Giới tính;</li>
          <li>
            d) Nơi sinh, nơi đăng ký khai sinh, nơi thường trú, nơi tạm trú, nơi
            ở hiện tại, quê quán, địa chỉ liên hệ;
          </li>
          <li>đ) Quốc tịch;</li>
          <li>e) Hình ảnh của cá nhân;</li>
          <li>
            g) Số điện thoại, số chứng minh nhân dân, số định danh cá nhân, số
            hộ chiếu, số giấy phép lái xe, số biển số xe, số mã số thuế cá nhân,
            số bảo hiểm xã hội, số thẻ bảo hiểm y tế;
          </li>
          <li>h) Tình trạng hôn nhân;</li>
          <li>i) Thông tin về mối quan hệ gia đình (cha mẹ, con cái);</li>
          <li>
            k) Thông tin về tài khoản số của cá nhân; địa chỉ thư điện tử; thông
            tin về hoạt động sử dụng Sản phẩm, hàng hóa, dịch vụ của Khách hàng,
            bao gồm: thư điện tử; thông tin liên quan đến việc sử dụng dịch vụ
            thoại và tin nhắn (ví dụ như số điện thoại khởi tạo cuộc gọi, số
            điện thoại nhận cuộc gọi, thời gian khởi tạo và kết thúc cuộc gọi,
            thời gian cuộc gọi, số điện thoại gửi tin nhắn, số điện thoại nhận
            tin nhắn, thời gian gửi và nhận tin nhắn); các gói cước đã đăng ký
            và thông tin cước (thông tin cước sử dụng, nợ cước, cước đóng
            trước...); phí dịch vụ, tiền cước; lịch sử sử dụng dữ liệu di động
            (sms, dịch vụ giá trị gia tăng, data...), thời gian sử dụng dữ liệu
            di động; dung lượng sử dụng, lịch sử và tần suất sử dụng Sản phẩm,
            hàng hóa, dịch vụ; địa chỉ IP; thông tin đánh giá Sản phẩm, hàng
            hóa, dịch vụ/khiếu nại/yêu cầu sửa chữa/xử lý sự cố và các thông tin
            khác về hoạt động sử dụng Sản phẩm, hàng hóa, dịch vụ của Khách
            hàng;
          </li>
          <li>
            l) Dữ liệu cá nhân phản ánh hoạt động, lịch sử hoạt động trên không
            gian mạng, bao gồm: các dữ liệu liên quan đến các Trang thông tin
            điện tử/wapsite/mạng xã hội hoặc Ứng dụng; dữ liệu kỹ thuật (bao gồm
            loại thiết bị, hệ điều hành, loại trình duyệt, cài đặt trình duyệt,
            địa chỉ IP, cài đặt ngôn ngữ, ngày và giờ kết nối với Trang thông
            tin điện tử, thống kê sử dụng Ứng dụng, cài đặt Ứng dụng, ngày và
            giờ kết nối với Ứng dụng, thông tin liên lạc kỹ thuật khác); tên tài
            khoản; mật khẩu; chi tiết đăng nhập bảo mật; dữ liệu sử dụng; dữ
            liệu cookie; lịch sử duyệt web; dữ liệu clickstream; lịch sử xem
            kênh, VOD (video theo yêu cầu)và các dữ liệu cá nhân phản ánh hoạt
            động, lịch sử hoạt động trên không gian mạng khác;
          </li>
          <li>
            m) Các thông tin khác gắn liền với một con người cụ thể hoặc giúp
            xác định một con người cụ thể.
          </li>
          <li>
            n) Dữ liệu cá nhân cơ bản khác theo quy định pháp luật tại từng thời
            điểm.
          </li>
          <li>2.2 Dữ liệu cá nhân nhạy cảm</li>
          <li>
            a) Dữ liệu cá nhân của tổ chức tín dụng, chi nhánh ngân hàng nước
            ngoài, tổ chức cung ứng dịch vụ trung gian thanh toán, các tổ chức
            được phép khác, gồm: thông tin định danh Khách hàng theo quy định
            của pháp luật, thông tin về tài khoản, thông tin về tiền gửi, thông
            tin về tài sản gửi, thông tin về giao dịch, thông tin về tổ chức, cá
            nhân là bên bảo đảm tại tổ chức tín dụng, chi nhánh ngân hàng, tổ
            chức cung ứng dịch vụ trung gian thanh toán;
          </li>
          <li>
            b) Thông tin tài khoản viễn thông của Khách hàng, bao gồm cả lịch sử
            thanh toán cước, nạp tiền vào tài khoản, số dư tài khoản viễn thông;
          </li>
          <li>
            c) Thông tin liên quan đến nguồn gốc dân tộc, thuộc tính vật lý, đặc
            điểm sinh học riêng mà Khách hàng cung cấp cho VNPT hoặc VNPT có
            được trong quá trình Khách hàng tìm kiếm, tiếp cận, mua, đăng ký sử
            dụng, sử dụng Sản phẩm, hàng hóa, dịch vụ;
          </li>
          <li>
            d) Dữ liệu về vị trí của cá nhân được xác định qua dịch vụ định vị;
          </li>
          <li>
            đ) Dữ liệu cá nhân khác được pháp luật quy định là đặc thù và cần có
            biện pháp bảo mật cần thiết.
          </li>
          <li>2.3 Thông tin bắt buộc và tùy chọn</li>
          <li>
            VNPT sẽ thông báo cho Khách hàng các Thông tin Khách hàng bắt buộc
            phải cung cấp (“Thông tin Khách hàng bắt buộc cung cấp”) và các
            Thông tin Khách hàng được lựa chọn đồng ý hoặc không đồng ý cung cấp
            (“Thông tin Khách hàng tùy chọn cung cấp”) tại thời điểm Khách hàng
            liên hệ, trao đổi hoặc đăng ký, ký kết hợp đồng với VNPT.
          </li>
          <li>
            Trong đó, Thông tin Khách hàng bắt buộc phải cung cấp được hiểu là
            các Thông tin Khách hàng mà VNPT cần phải thu thập từ Khách hàng
            theo quy định của pháp luật hoặc các Thông tin Khách hàng mà VNPT
            bắt buộc phải sử dụng để triển khai cung cấp một phần hoặc toàn bộ
            Sản phẩm, dịch vụ của VNPT theo yêu cầu của Khách hàng.
          </li>
          <li>
            Thông tin Khách hàng tùy chọn cung cấp được hiểu là các Thông tin
            Khách hàng mà VNPT thu thập để nâng cao trải nghiệm khách hàng, dự
            đoán hành vi tiêu dùng hoặc nghiên cứu thị trường dịch vụ viễn
            thông, việc không cung cấp Thông tin Khách hàng tùy chọn cung cấp
            không làm ảnh hưởng tới việc cung cấp Sản phẩm, dịch vụ của VNPT
            theo yêu cầu của Khách hàng. Nếu các Thông tin Khách hàng bắt buộc
            cung cấp không được cung cấp theo yêu cầu của VNPT, Khách hàng sẽ
            không thể sử dụng Sản phẩm, dịch vụ của VNPT. Trong trường hợp này,
            VNPT có thể từ chối cung cấp sản phẩm, dịch vụ cho Khách hàng mà
            không phải chịu bất kì một khoản bồi thường và/hoặc phạt vi phạm nào
            (trừ trường hợp do lỗi của VNPT hoặc pháp luật có quy định khác).
          </li>
          <li>2.4 Ủy quyền hoặc thuê bên thứ ba</li>
          <li>
            VNPT có thể tự mình hoặc ủy quyền, thuê bên thứ ba thực hiện xử lý
            Thông tin Khách hàng với điều kiện là việc xử lý Thông tin Khách
            hàng phải bảo đảm an toàn, an ninh Thông tin Khách hàng theo quy
            định của pháp luật.
          </li>
          <li>
            Trường hợp VNPT ủy quyền hoặc thuê bên thứ ba thực hiện việc xử lý
            Thông tin Khách hàng thì phải được sự đồng ý của Khách hàng. Việc ủy
            quyền hoặc thuê bên thứ ba phải được thực hiện bằng văn bản, trong
            đó quy định rõ phạm vi, trách nhiệm của mỗi bên trong việc bảo vệ
            Thông tin Khách hàng theo quy định của pháp luật.
          </li>
          <li>
            Trường hợp Khách hàng thực hiện giao dịch thông qua bên thứ ba thì
            bên thứ ba có trách nhiệm bảo vệ Thông tin Khách hàng theo quy định
            của pháp luật.
          </li>
        </ul>
      </div>
    ),
  },
  {
    title: "Điều 3. Mục đích xử lý Thông tin Khách hàng",
    content: (
      <div className="text-sm sm:text-base text-left">
        <ul className="list-none ">
          <li>1. Mục đích bắt buộc</li>
          <li>
            VNPT được phép tiến hành xử lý Thông tin Khách hàng trong các trường
            hợp sau (“Mục đích bắt buộc”):
          </li>
          <li>
            a) Cung cấp sản phẩm, dịch vụ của VNPT theo yêu cầu của Khách hàng
            và chỉ trong phạm vi thông tin mà Khách hàng đã đồng ý (Theo Điểm b
            Khoản 3 Điều 18 Luật bảo vệ quyền lợi người tiêu dùng 2023), bao
            gồm:
          </li>
          <li>
            - Xác minh tính chính xác, đầy đủ của các thông tin được Khách hàng
            cung cấp theo quy định của pháp luật; xác định hoặc xác thực danh
            tính của Khách hàng và thực hiện quy trình xác thực Khách hàng; Xử
            lý việc đăng ký sử dụng Sản phẩm, dịch vụ của VNPT;
          </li>
          <li>
            - Thẩm định hồ sơ và khả năng đủ điều kiện của Khách hàng đối với
            việc sử dụng Sản phẩm, dịch vụ của VNPT. VNPT có thể sử dụng các
            phương pháp chấm điểm, gán ngưỡng cước nóng, kiểm tra lịch sử Khách
            hàng sử dụng Sản phẩm, dịch vụ của VNPT để đánh giá và quản trị rủi
            ro tín dụng, đảm bảo khả năng thanh toán đối với các nghĩa vụ thanh
            toán và các nghĩa vụ khác có liên quan trong suốt quá trình cung cấp
            Sản phẩm, dịch vụ của VNPT cho Khách hàng;
          </li>
          <li>
            Thực hiện các quyền của Khách hàng liên quan đến Thông tin Khách
            hàng theo quy định pháp luật, thỏa thuận giữa Khách hàng và VNPT;
          </li>
          <li>
            - Thông báo tới Khách hàng thông tin về kế hoạch tác động mạng lưới
            liên quan đến Sản phẩm, dịch vụ của VNPT;
          </li>
          <li>
            - Quản lý tài khoản Khách hàng và các chương trình Khách hàng thân
            thiết;
          </li>
          <li>
            - Tiếp nhận giải quyết các yêu cầu, khiếu nại, khiếu kiện của Khách
            hàng; gửi các thông báo cho Khách hàng nhằm khảo sát sự hài lòng của
            Khách hàng đối với chất lượng sản phẩm, dịch vụ, quy trình giải
            quyết yêu cầu, khiếu nại, khiếu kiện do VNPT thực hiện;
          </li>
          <li>
            - Liên hệ với Khách hàng nhằm tư vấn, trao đổi thông tin, giải quyết
            yêu cầu, khiếu nại, giao các hóa đơn, các sao kê, các báo cáo hoặc
            các tài liệu khác liên quan tới Sản phẩm, dịch vụ của VNPT thông qua
            các kênh khác nhau (ví dụ: email, chat) và để trả lời yêu cầu của
            Khách hàng. Liên hệ với Khách hàng (hoặc các bên do Khách hàng chỉ
            định hoặc yêu cầu) để thông báo cho Khách hàng về thông tin liên
            quan đến việc sử dụng Sản phẩm, dịch vụ của VNPT;
          </li>
          <li>
            - Đánh giá hiệu quả sản xuất kinh doanh của các đơn vị; vận hành hệ
            thống quản trị nội bộ, hệ thống đánh giá hiệu quả công việc và các
            hệ thống giám sát hoạt động sản xuất kinh doanh;
          </li>
          <li>
            - Lập hồ sơ phục vụ công tác mời thầu hoặc tham dự thầu; lập báo
            cáo, thống kê, phân tích dữ liệu nội bộ để nghiên cứu, xây dựng,
            phát triển, quản lý, đo lường, cung cấp và cải tiến Sản phẩm, hàng
            hóa, dịch vụ cũng như điều hành hoạt động kinh doanh của VNPT;
          </li>
          <li>
            - Đánh giá khả năng mua, sử dụng sản phẩm, hàng hóa, dịch vụ của
            VNPT thông qua điểm xếp hạng viễn thông của Khách hàng nhằm hỗ trợ
            tốt nhất trong việc cung cấp các sản phẩm, hàng hóa, dịch vụ cho
            Khách hàng;
          </li>
          <li>
            - Cung cấp thông tin mà Khách hàng yêu cầu hoặc nhận định rằng Khách
            hàng có thể thấy hữu ích, bao gồm thông tin về các Sản phẩm, dịch vụ
            của VNPT theo quy định pháp luật;
          </li>
          <li>
            - Cải tiến công nghệ, giao diện website/ứng dụng cung cấp dịch vụ
            đảm bảo tối ưu hóa trải nghiệm của Khách hàng.
          </li>
          <li>
            b) Thực hiện các nghĩa vụ theo quy định của pháp luật (Theo Điểm c
            Khoản 3 Điều 18 Luật bảo vệ quyền lợi người tiêu dùng 2023), bao
            gồm:
          </li>
          <li>
            - Lập các loại báo cáo theo quy định của pháp luật về viễn thông,
            truyền hình hoặc theo yêu cầu bằng văn bản của cơ quan quản lý nhà
            nước có thẩm quyền;
          </li>
          <li>
            - Trong trường hợp khẩn cấp, cần xử lý ngay Thông tin Khách hàng có
            liên quan để bảo vệ tính mạng, sức khỏe của chủ thể dữ liệu hoặc
            người khác với điều kiện là việc xử lý thông tin này phải phù hợp
            với quy định của pháp luật;
          </li>
          <li>
            - Việc công khai Thông tin Khách hàng theo quy định của luật; tuân
            thủ các nghĩa vụ của doanh nghiệp cung cấp dịch vụ viễn thông,
            truyền hình theo quy định của pháp luật;
          </li>
          <li>
            - Việc xử lý dữ liệu của cơ quan nhà nước có thẩm quyền trong trường
            hợp tình trạng khẩn cấp về quốc phòng, an ninh quốc gia, trật tự an
            toàn xã hội, thảm họa lớn, dịch bệnh nguy hiểm; khi có nguy cơ đe
            dọa an ninh, quốc phòng nhưng chưa đến mức ban bố tình trạng khẩn
            cấp; phòng, chống bạo loạn, khủng bố, phòng, chống tội phạm và vi
            phạm pháp luật theo quy định của luật;
          </li>
          <li>
            - Để thực hiện nghĩa vụ theo hợp đồng của chủ thể dữ liệu với cơ
            quan, tổ chức, cá nhân có liên quan theo quy định của pháp luật;
          </li>
          <li>
            - Phục vụ hoạt động của cơ quan nhà nước đã được quy định theo pháp
            luật chuyên ngành.
          </li>
          <li>2. Mục đích tùy chọn</li>
          <li>
            Trừ trường hợp quy định tại khoản 3.1, VNPT phải thực hiện thông báo
            và lấy chấp thuận của Khách hàng trước khi xử lý Thông tin Khách
            hàng của Khách hàng đối với các mục đích được liệt kê dưới đây (sau
            đây gọi tắt là “Mục đích tùy chọn”). Thông tin Khách hàng thu thập,
            cập nhật, bổ sung phải phù hợp và giới hạn trong phạm vi, mục đích
            cần xử lý theo quy định tại Chính sách này.
          </li>
          <li>
            a) Mục đích kinh doanh các dịch vụ phân tích dữ liệu, dịch vụ xác
            thực, dịch vụ định danh, dịch vụ quảng cáo, dịch vụ tiếp thị, nghiên
            cứu thị trường, thăm dò dư luận, môi giới. Đối với dịch vụ tiếp thị,
            phương thức, hình thức, tần suất giới thiệu sản phẩm thực hiện theo
            quy định của pháp luật về bảo vệ dữ liệu cá nhân.
          </li>
          <li>
            b) Tổ chức chương trình quảng cáo, giới thiệu sản phẩm, hàng hóa,
            dịch vụ và thực hiện các hoạt động xúc tiến thương mại đối với sản
            phẩm, hàng hóa, dịch vụ do VNPT cung cấp, bao gồm các hoạt động sử
            dụng Thông tin Khách hàng để quảng cáo, tiếp thị với Khách hàng về
            các chương trình khuyến mại, nghiên cứu, khảo sát, tin tức, thông
            tin cập nhật, các sự kiện, cuộc thi có thưởng, trao các phần thưởng
            có liên quan, các quảng cáo và nội dung có liên quan về Sản phẩm,
            dịch vụ của VNPT. Trường hợp Khách hàng không muốn tiếp tục nhận
            email, tin nhắn và/hoặc bản tin định kỳ với mục đích quảng cáo, tiếp
            thị của VNPT, Khách hàng có thể từ chối theo cách thức đã được VNPT
            hướng dẫn trên các kênh, phương tiện như tin nhắn, cuộc gọi, dấu
            tích trên website/ứng dụng cung cấp dịch vụ hoặc liên hệ với tổng
            đài chăm sóc Khách hàng của VNPT.
          </li>
          <li>3. Cấm mua bán thông tin</li>
          <li>
            VNPT không thực hiện hoạt động mua bán Thông tin Khách hàng dưới bất
            kỳ hình thức nào.
          </li>
        </ul>
      </div>
    ),
  },
  {
    title: "Điều 4. Cách thức xử lý Thông tin Khách hàng",
    content: (
      <div className="text-sm sm:text-base text-left">
        <ul className="list-none ">
          <li>
            VNPT áp dụng một hoặc nhiều hoạt động tác động tới Thông tin Khách
            hàng như: thu thập, ghi, phân tích, xác nhận, lưu trữ, chỉnh sửa,
            công khai, kết hợp, truy cập, truy xuất, thu hồi, mã hóa, giải mã,
            sao chép, chia sẻ, truyền đưa, cung cấp, chuyển giao, xóa, hủy Thông
            tin Khách hàng hoặc các hành động khác có liên quan phù hợp với quy
            định của pháp luật.
          </li>
        </ul>
      </div>
    ),
  },
  {
    title: "Điều 5. Thời gian bắt đầu, thời gian kết thúc xử lý dữ liệu",
    content: (
      <div className="text-sm sm:text-base text-left">
        <ul className="list-none">
          <li>
            1. Thời gian bắt đầu xử lý dữ liệu: Kể từ thời điểm phát sinh các
            Mục Đích quy định tại Điều 3 Chính sách này.
          </li>
          <li>2. Thời gian kết thúc xử lý dữ liệu</li>
          <li>
            VNPT chấm dứt việc xử lý Thông tin Khách hàng khi đã hoàn thành Mục
            Đích quy định tại Chính sách này, trừ trường hợp pháp luật có quy
            định khác hoặc Khách hàng rút lại sự đồng ý việc xử lý Thông tin
            Khách hàng hoặc khi cơ quan nhà nước có thẩm quyền yêu cầu bằng văn
            bản.
          </li>
        </ul>
      </div>
    ),
  },
  {
    title: "Điều 6. Phạm vi sử dụng Thông tin Khách hàng",
    content: (
      <div className="text-sm sm:text-base text-left">
        <ul className="list-none ">
          <li>
            1. VNPT được phép chia sẻ Thông tin Khách hàng của Khách hàng cho
            các tổ chức, cá nhân dưới đây để thực hiện các Mục Đích quy định tại
            Chính sách (“Phạm vi sử dụng bắt buộc”), cụ thể:
          </li>
          <li>
            - Chia sẻ thông tin với Công ty con của VNPT, công ty liên kết của
            VNPT, công ty liên kết của Công ty con của VNPT (Theo Nghị định
            25/2016/NĐ-CP);
          </li>
          <li>
            - Chia sẻ thông tin với Bên thứ ba cung cấp dịch vụ cho VNPT hoặc
            các đối tác trong các hợp đồng hợp tác kinh doanh nhằm phát triển
            sản phẩm, dịch vụ của VNPT và hai bên đã có thỏa thuận bằng văn bản
            về việc bên thứ ba có trách nhiệm bảo vệ Thông tin Khách hàng (Theo
            Điểm a Khoản 4 Điều 18 Luật bảo vệ quyền lợi người tiêu dùng 2023),
            cụ thể: VNPT sử dụng và/hoặc hợp tác với các công ty và cá nhân khác
            để thực hiện một số công việc và chương trình như chương trình quảng
            cáo, khuyến mại dành cho Khách hàng, nghiên cứu thị trường, phân
            tích và phát triển sản phẩm, tư vấn chiến lược, cung cấp dịch vụ thu
            cước. Các Bên thứ ba cung cấp dịch vụ và/hoặc các đối tác này có
            quyền truy cập, thu thập, sử dụng và xử lý Thông tin Khách hàng của
            Khách hàng trong phạm vi Khách hàng đã đồng ý và VNPT cho phép để
            thực hiện các chức năng của họ và phải tuân thủ quy định của pháp
            luật về bảo vệ Thông tin Khách hàng với tư cách là Bên Xử lý Dữ
            Liệu, có văn bản/thỏa thuận về xử lý Thông tin Khách hàng xác định
            rõ phạm vi, mục đích, loại Thông tin Khách hàng được chia sẻ, các
            quyền nghĩa vụ của các bên và trách nhiệm của Bên Xử lý Thông tin
            Khách hàng đối với việc bảo vệ Thông tin Khách hàng;
          </li>
          <li>
            - Chia sẻ thông tin với các doanh nghiệp viễn thông có thỏa thuận
            bằng văn bản với Bên B về việc trao đổi, cung cấp thông tin thuê bao
            viễn thông, thông tin về việc sử dụng dịch vụ viễn thông của người
            sử dụng dịch vụ để phục vụ cho việc tính giá, lập hóa đơn (Theo quy
            định tại Điểm b Khoản 4 Điều 6 Luật Viễn thông 2023);
          </li>
          <li>
            - Cung cấp thông tin thuê bao viễn thông có hành vi trốn tránh thực
            hiện nghĩa vụ thanh toán tiền sử dụng dịch vụ viễn thông theo quy
            định của Bộ trưởng Bộ Thông tin và Truyền thông (Theo quy định tại
            Điểm c Khoản 4 Điều 6 Luật Viễn thông 2023);
          </li>
          <li>
            - Khi có yêu cầu của cơ quan nhà nước có thẩm quyền, theo quy định
            của pháp luật (Theo quy định tại Điểm d Khoản 4 Điều 6 Luật Viễn
            thông 2023).
          </li>
          <li>
            2. Ngoài các đối tượng quy định tại Điều 6.1 Chính sách này, việc
            chia sẻ Thông tin Khách hàng cho bất kì bên thứ ba nào khác phải
            được sự chấp thuận của Khách hàng (“Phạm vi sử dụng tùy chọn”).
          </li>
        </ul>
      </div>
    ),
  },
  {
    title: "Điều 7. Quyền của Khách hàng",
    content: (
      <div className="text-sm sm:text-base text-left">
        <ul className="list-none">
          <li>1. Quyền được biết và Quyền đồng ý</li>
          <li>
            Khách hàng có quyền được biết về hoạt động xử lý Thông tin Khách
            hàng của mình, trừ trường hợp pháp luật có quy định khác. Khách hàng
            có quyền đồng ý hoặc không đồng ý với các điều khoản và điều kiện
            của Chính sách này theo cách thức đã được VNPT hướng dẫn trên các
            kênh, phương tiện như tin nhắn SMS, cuộc gọi, dấu tích trên
            website/ứng dụng cung cấp dịch vụ hoặc liên hệ với tổng đài chăm sóc
            khách hàng của VNPT phù hợp với quy định của pháp luật. VNPT chỉ
            thực hiện xử lý Thông tin Khách hàng khi đã có chấp thuận của Khách
            hàng.
          </li>
          <li>2. Quyền truy cập và yêu cầu cung cấp Thông tin Khách hàng</li>
          <li>
            Khách hàng có quyền truy cập vào các ứng dụng cung cấp dịch
            vụ/website của VNPT và/hoặc liên hệ trực tiếp với VNPT để xem, chỉnh
            sửa, trích xuất các Thông tin Khách hàng của Khách hàng, trừ trường
            hợp pháp luật có quy định khác.
          </li>
          <li>
            Trường hợp Khách hàng không thể tự truy cập để xem, chỉnh sửa, trích
            xuất hoặc gặp khó khăn trong việc truy cập để xem, chỉnh sửa hoặc
            trích xuất các Thông tin Khách hàng, Khách hàng vui lòng liên hệ với
            VNPT để được hỗ trợ.
          </li>
          <li>3. Quyền chỉnh sửa</li>
          <li>
            Khách hàng có quyền chỉnh sửa các Thông tin Khách hàng của mình với
            điều kiện việc chỉnh sửa này không vi phạm các quy định của pháp
            luật. Trường hợp Khách hàng không thể tự chỉnh sửa hoặc gặp khó khăn
            trong việc chỉnh sửa các Thông tin Khách hàng, Khách hàng có thể
            liên hệ với VNPT để được hỗ trợ.
          </li>
          <li>4. Quyền phản đối, hạn chế, rút lại sự đồng ý xử lý dữ liệu</li>
          <li>
            a) Khách hàng có quyền phản đối, yêu cầu hạn chế xử lý Thông tin
            Khách hàng hoặc rút lại sự đồng ý xử lý Thông tin Khách hàng. Tuy
            nhiên, việc phản đối, hạn chế hoặc rút lại sự đồng ý xử lý Thông tin
            Khách hàng bắt buộc cung cấp tại Điều 2 hoặc phản đối, hạn chế hoặc
            rút lại sự đồng ý xử lý Thông tin Khách hàng phục vụ các Mục đích
            bắt buộc tại Điều 3 hoặc phản đối, hạn chế hoặc rút lại sự đồng ý
            đối với Phạm vi sử dụng bắt buộc tại Điều 6 sẽ dẫn tới việc VNPT
            không thể cung cấp Sản phẩm, dịch vụ cho Khách hàng, điều này đồng
            nghĩa với việc VNPT có thể đơn phương chấm dứt hợp đồng mà không cần
            phải bồi thường cho Khách hàng do các điều kiện để thực hiện hợp
            đồng đã thay đổi (trừ trường hợp do lỗi của VNPT).
          </li>
          <li>
            b) Trường hợp Khách hàng muốn phản đối, hạn chế, rút lại sự đồng ý
            xử lý Thông tin Khách hàng phục vụ các Mục đích tùy chọn quy định
            tại Điều 3 Chính sách này hoặc phản đối, hạn chế, rút lại sự đồng ý
            xử lý Thông tin Khách hàng tùy chọn cung cấp hoặc hoặc phản đối, hạn
            chế, rút lại sự đồng ý xử lý đối với Phạm vi sử dụng tùy chọn, Khách
            hàng thực hiện theo hướng dẫn của VNPT tại thời điểm VNPT thu thập
            Thông tin Khách hàng hoặc liên hệ với VNPT theo các thông tin được
            cung cấp tại Chính sách này. Nếu Khách hàng không muốn nhận thông
            báo từ ứng dụng cung cấp dịch vụ của VNPT, vui lòng điều chỉnh cài
            đặt thông báo trong ứng dụng cung cấp dịch vụ hoặc thiết bị của
            mình.
          </li>
          <li>5. Quyền xóa Thông tin Khách hàng</li>
          <li>
            Khách hàng có quyền yêu cầu VNPT thực hiện xóa Thông tin Khách hàng
            của Khách hàng với điều kiện là yêu cầu của Khách hàng phải phù hợp
            với quy định của pháp luật và không thuộc trường hợp VNPT phải lưu
            trữ Thông tin Khách hàng theo quy định pháp luật. Tuy nhiên, yêu cầu
            xóa Thông tin Khách hàng bắt buộc cung cấp theo quy định pháp luật
            sẽ dẫn tới việc VNPT không thể cung cấp Sản phẩm, dịch vụ cho Khách
            hàng, điều này đồng nghĩa với việc VNPT có thể đơn phương chấm dứt
            hợp đồng mà không cần phải bồi thường cho Khách hàng do các điều
            kiện để thực hiện hợp đồng đã thay đổi (trừ trường hợp do lỗi của
            VNPT hoặc pháp luật có quy định khác).
          </li>
          <li>6. Quyền khiếu nại, tố cáo, khởi kiện:</li>
          <li>
            Khách hàng có quyền khiếu nại, tố cáo hoặc khởi kiện theo quy định
            của pháp luật.
          </li>
          <li>7. Quyền yêu cầu bồi thường thiệt hại</li>
          <li>
            Khách hàng có quyền yêu cầu bồi thường thiệt hại theo quy định của
            pháp luật khi xảy ra vi phạm quy định về bảo vệ Thông tin Khách hàng
            của mình, trừ trường hợp các bên có thỏa thuận khác hoặc luật có quy
            định khác.
          </li>
          <li>8. Quyền tự bảo vệ</li>
          <li>
            Khách hàng có quyền tự bảo vệ theo quy định của Bộ luật Dân sự, luật
            khác có liên quan và Nghị định 13/2023/NĐ-CP về bảo vệ Thông tin
            Khách hàng (và các bản sửa đổi kèm theo), hoặc yêu cầu cơ quan, tổ
            chức có thẩm quyền thực hiện các phương thức bảo vệ quyền dân sự
            theo quy định tại Điều 11 Bộ luật Dân sự.
          </li>
        </ul>
      </div>
    ),
  },
  {
    title: "Điều 8. Nghĩa vụ của Khách hàng",
    content: (
      <div className="text-sm sm:text-base text-left">
        <ul className="list-none">
          <li>
            Khách hàng có trách nhiệm bảo vệ Thông tin Khách hàng của mình như
            sau:
          </li>
          <li>
            1. Chủ động thực hiện các biện pháp bảo vệ, quản lý và sử dụng an
            toàn tài khoản, thiết bị công nghệ cá nhân (bao gồm các thiết bị như
            điện thoại thông minh, máy tính, máy tính bảng, laptop) bằng cách
            đăng xuất tài khoản sau khi sử dụng, đặt một mật khẩu mạnh và giữ bí
            mật thông tin đăng nhập cũng như mật khẩu của mình. Các biện pháp
            bảo vệ và quản lý sử dụng an toàn tài khoản, thiết bị di động nói
            trên giúp ngăn chặn việc truy cập trái phép vào tài khoản của Khách
            hàng. VNPT được loại trừ trách nhiệm với các thiệt hại của Khách
            hàng trong trường hợp Khách hàng bị lộ/mất, bị đánh cắp mật khẩu,
            dẫn tới việc bị truy cập trái phép vào tài khoản, hoặc bất kỳ hoạt
            động nào trên tài khoản của Khách hàng sử dụng trên thiết bị di động
            bị mất, thất lạc dẫn đến người không có thẩm quyền tự ý sử dụng dịch
            vụ, hoặc hệ thống của VNPT bị xâm phạm bất hợp pháp bởi bên thứ ba
            mặc dù VNPT đã thực hiện đầy đủ các biện pháp để bảo vệ hệ thống
            (trừ trường hợp do lỗi của VNPT);
          </li>
          <li>
            2. Khi đã chấp thuận toàn bộ điều khoản và điều kiện của của Chính
            sách này, Khách hàng có trách nhiệm cung cấp Thông tin Khách hàng
            đầy đủ, chính xác theo yêu cầu của VNPT và có trách nhiệm thông báo
            cho VNPT ngay khi phát hiện hành vi vi phạm quy định về bảo vệ Thông
            tin Khách hàng;
          </li>
          <li>
            3. Khách hàng có trách nhiệm tôn trọng Thông tin Khách hàng của chủ
            thể khác và thực hiện quy định của pháp luật về bảo vệ Thông tin
            Khách hàng, tham gia phòng, chống các hành vi vi phạm quy định về
            bảo vệ Thông tin Khách hàng.
          </li>
        </ul>
      </div>
    ),
  },
  {
    title: "Điều 9. Lưu trữ Thông tin Khách hàng / Phạm vi sử dụng",
    content: (
      <div className="text-sm sm:text-base text-left">
        <ul className="list-none">
          <li>1. Địa điểm lưu trữ Thông tin Khách hàng:</li>
          <li>
            Trong phạm vi pháp luật cho phép, VNPT có thể lưu trữ Thông tin
            Khách hàng của Khách hàng tại Việt Nam và ở nước ngoài, kể cả trên
            giải pháp lưu trữ điện toán đám mây. VNPT áp dụng các tiêu chuẩn về
            bảo mật dữ liệu phù hợp với quy định pháp luật hiện hành. Việc
            chuyển Thông tin Khách hàng ra nước ngoài phải phù hợp với quy định
            tại Điều 25 Nghị định 13/2023/NĐ-CP (và các bản sửa đổi kèm theo) và
            các quy định của pháp luật.
          </li>
          <li>2. Thời gian lưu trữ Thông tin Khách hàng:</li>
          <li>
            Trừ trường hợp pháp luật có quy định khác, VNPT chỉ thực hiện lưu
            trữ Thông tin Khách hàng của Khách hàng để hoàn thành các Mục Đích
            bắt buộc (và các Mục đích tùy chọn trong trường hợp được Khách hàng
            đồng ý) quy định tại Chính sách này.
          </li>
        </ul>
      </div>
    ),
  },
  {
    title: "Điều 10. Nghĩa vụ của VNPT",
    content: (
      <div className="text-sm sm:text-base text-left">
        <ul className="list-none">
          <li>
            1. Thông tin Khách hàng của Khách hàng được cam kết bảo mật theo quy
            định của pháp luật, Chính sách bảo vệ Thông tin Khách hàng của VNPT.
            VNPT phải có các biện pháp bảo vệ Thông tin Khách hàng theo quy định
            của pháp luật, trong đó các biện pháp ngăn chặn các hành vi sau đây:
          </li>
          <li>a) Đánh cắp hoặc tiếp cận thông tin trái phép;</li>
          <li>b) Sử dụng thông tin trái phép;</li>
          <li>c) Chỉnh sửa, cập nhật, hủy bỏ thông tin trái phép.</li>
          <li>
            2. VNPT áp dụng những biện pháp vật lý, điện tử và quản lý để bảo vệ
            Thông tin Khách hàng, bao gồm:
          </li>
          <li>
            a) Các máy chủ trang thông tin điện tử chính thức của VNPT và các hệ
            thống thông tin chứa Thông tin Khách hàng của VNPT đều được bảo vệ
            bởi các biện pháp, công nghệ bảo mật như tường lửa, mã hóa, chống
            xâm nhập trái phép; ban hành các biện pháp kiểm soát về con người,
            xây dựng quy trình kiểm tra, đánh giá, rà soát để phòng tránh các
            hành vi vi phạm quy định về bảo vệ Thông tin Khách hàng.
          </li>
          <li>
            b) VNPT sẽ thực hiện tất cả các biện pháp cần thiết để đảm bảo rằng
            Thông tin Khách hàng của Khách hàng được xử lý đúng với Mục Đích đã
            thông báo và được Khách hàng đồng ý. VNPT sẽ luôn tuân thủ những yêu
            cầu của pháp luật liên quan đến việc xử lý Thông tin Khách hàng.
          </li>
          <li>
            3. Thực hiện các yêu cầu của Khách hàng liên quan đến Thông tin
            Khách hàng của Khách hàng với điều kiện các yêu cầu của Khách hàng
            phải phù hợp với quy định của pháp luật.
          </li>
          <li>
            4. Trong trường hợp hệ thống thông tin bị tấn công làm phát sinh
            nguy cơ mất an toàn, an ninh Thông tin Khách hàng, VNPT hoặc bên lưu
            trữ thông tin liên quan phải thông báo cho cơ quan quản lý nhà nước
            có thẩm quyền trong thời hạn theo quy định của pháp luật và thực
            hiện các biện pháp cần thiết để bảo đảm an toàn, an ninh Thông tin
            Khách hàng theo quy định của pháp luật về an ninh mạng, an toàn
            thông tin mạng, giao dịch điện tử và quy định khác của pháp luật có
            liên quan.
          </li>
          <li>
            5. Các nghĩa vụ khác theo quy định của pháp luật và của Chính sách
            này.
          </li>
        </ul>
      </div>
    ),
  },
  {
    title: "Điều 11. Hậu quả, thiệt hại không mong muốn có khả năng xảy ra",
    content: (
      <div className="text-sm sm:text-base text-left">
        <ul className="list-none ">
          <li>
            1. VNPT sử dụng nhiều biện pháp, công nghệ bảo mật thông tin khác
            nhau nhằm bảo vệ Thông tin Khách hàng của Khách hàng không bị sử
            dụng hoặc chia sẻ ngoài ý muốn trong quá trình xử lý Thông tin Khách
            hàng (bao gồm cả dữ liệu sinh trắc học của Khách hàng). VNPT cam kết
            sẽ bảo mật một cách tối đa Thông tin Khách hàng. Một số hậu quả,
            thiệt hại, rủi ro không mong muốn có thể xảy ra bao gồm:
          </li>
          <li>
            a) Lỗi phần cứng, phần mềm trong quá trình xử lý Thông tin Khách
            hàng gây ảnh hưởng không mong muốn (lỗi, hỏng, mất) Thông tin Khách
            hàng của Khách hàng;
          </li>
          <li>
            b) Lỗ hổng bảo mật nằm ngoài khả năng kiểm soát của VNPT, hệ thống
            bị hacker tấn công gây lộ lọt Thông tin Khách hàng của Khách hàng;
          </li>
          <li>
            c) Khách hàng tự làm lộ lọt Thông tin Khách hàng của Khách hàng do:
            bất cẩn hoặc bị lừa đảo; truy cập các website/tải các ứng dụng cung
            cấp dịch vụ có chứa phần mềm độc hại; tự ý chia sẻ thông tin với
            người khác.
          </li>
          <li>
            2. VNPT khuyến cáo Khách hàng thực hiện nghiêm ngặt các trách nhiệm
            bảo vệ Thông tin Khách hàng theo quy định tại Điều 8 Chính sách này
            và theo quy định của pháp luật.
          </li>
          <li>
            3. Trong trường hợp xảy ra lỗi phần cứng, phần mềm trong quá trình
            xử lý Thông tin Khách hàng theo quy định tại Điểm a Khoản 1 Điều
            này, VNPT có trách nhiệm bồi thường thiệt hại cho Khách hàng theo
            quy định tại Hợp đồng và theo quy định pháp luật.
          </li>
        </ul>
      </div>
    ),
  },
  {
    title: "Điều 12. Quảng cáo trên internet và bên thứ ba",
    content: (
      <div className="text-sm sm:text-base text-left">
        <ul className="list-none">
          <li>
            Các website/ứng dụng cung cấp dịch vụ của VNPT có thể bao gồm quảng
            cáo của bên thứ ba và liên kết tới các website/ứng dụng cung cấp
            dịch vụ khác. Các đối tác quảng cáo bên thứ ba có thể thu thập thông
            tin về Khách hàng khi Khách hàng tương tác với nội dung, quảng cáo
            hoặc dịch vụ của họ. Mọi quyền truy cập và sử dụng các liên kết hoặc
            trang website của bên thứ ba không bị điều chỉnh bởi Chính sách này,
            mà thay vào đó được điều chỉnh bởi chính sách quyền riêng tư của các
            bên thứ ba đó.
          </li>
        </ul>
      </div>
    ),
  },
  {
    title: "Điều 13. Luật áp dụng",
    content: (
      <div className="text-sm sm:text-base text-left">
        <ul className="list-none ">
          <li>
            Chính sách này được soạn thảo và điều chỉnh bởi pháp luật Việt Nam.
          </li>
        </ul>
      </div>
    ),
  },
  {
    title: "Điều 14. Thông tin liên lạc",
    content: (
      <div className="text-sm sm:text-base text-left">
        <ul className="list-none ">
          <li>
            Trường hợp Khách hàng có bất kỳ câu hỏi nào về Chính sách này hoặc
            muốn thực hiện các quyền của Khách hàng liên quan tới Thông tin
            Khách hàng, vui lòng liên hệ với VNPT theo các phương thức và thông
            tin dưới đây:
          </li>
          <li>
            1. Liên hệ tới tổng đài theo thông tin tại các website/ứng dụng cung
            cấp dịch vụ chính thức của VNPT tại từng thời điểm.
          </li>
          <li>
            2. Liên hệ trực tiếp tại các điểm giao dịch của VNPT trên phạm vi
            toàn quốc.
          </li>
          <li>
            3. Các cách thức liên hệ khác như Livechat (phần mềm trò chuyện trực
            tuyến), liên hệ qua fanpage (trang thông tin điện tử) chính thức của
            VNPT, email chăm sóc Khách hàng được cung cấp cho Khách hàng tại mọi
            thời điểm.
          </li>
        </ul>
      </div>
    ),
  },
];
export default function Policy() {
  return (
    <>
      <section className="w-full px-4 lg:px-0 lg:w-4/5 mx-auto py-4">
        <h2 className="font-bold text-base lg:text-[30px] text-[#1F7ED0] lg:mb-6 lg:mt-12 text-center lg:text-left">
          CHÍNH SÁCH BẢO VỆ THÔNG TIN KHÁCH HÀNG CỦA TẬP ĐOÀN BƯU CHÍNH VIỄN THÔNG VIỆT NAM
        </h2>

        {policies.map((item, index) => (
          <div key={index} className="flex flex-col lg:gap-6">
            <div className="lg:bg-[#E9E9E9] p-4 rounded-[10px] mt-5">
              <div className="bg-white lg:border lg:rounded-[10px] lg:border-[#1F7ED0] overflow-hidden">
                <div
                  className={`relative flex items-center px-4 py-2 gap-4
              ${
                index === 0
                  ? "bg-white text-black"
                  : "bg-[linear-gradient(89.99deg,_#3CD39C_36.54%,_#1F7ED0_99.99%)] text-white"
              }
            `}
                >
                  {index !== 0 && (
                    <div
                      className="absolute top-0 right-0 h-full w-10
                bg-[linear-gradient(134.3deg,_#42DDA5_49.75%,_#1679CF_99.48%)]
                [clip-path:polygon(100%_0,_0_0,_100%_100%)]"
                    />
                  )}

                  <h3 className="text-base lg:text-[22px] font-bold relative z-10">
                    {item.title}
                  </h3>
                </div>

                {/* CONTENT */}
                <div className="px-5 pb-4 pt-3 text-sm text-black animate-fadeIn">
                  {item.content}
                </div>
              </div>
            </div>
          </div>
        ))}
      </section>
    </>
  );
}
